import { render, staticRenderFns } from "./order-table.vue?vue&type=template&id=c7f7963c&scoped=true&"
import script from "./order-table.component.ts?vue&type=script&lang=ts&"
export * from "./order-table.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-table.scss?vue&type=style&index=0&id=c7f7963c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f7963c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7f7963c')) {
      api.createRecord('c7f7963c', component.options)
    } else {
      api.reload('c7f7963c', component.options)
    }
    module.hot.accept("./order-table.vue?vue&type=template&id=c7f7963c&scoped=true&", function () {
      api.rerender('c7f7963c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/milk-run/components/order-table/order-table.vue"
export default component.exports